import {
  CORE_LOAD_ALL_LICENSETYPE_REQUEST,
  CORE_LOAD_ALL_LICENSETYPE_SUCCESS,
  CORE_LOAD_ALL_LICENSETYPE_FAILURE,

  CORE_LOAD_LICENSETYPE_REQUEST,
  CORE_LOAD_LICENSETYPE_SUCCESS,
  CORE_LOAD_LICENSETYPE_FAILURE,
} from '../types'

const initialState = []
  , initialStateObj = {}
  , requestState = 'request'
export default {
  allLicensetype: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_LICENSETYPE_REQUEST:
        return requestState
      case CORE_LOAD_ALL_LICENSETYPE_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_ALL_LICENSETYPE_FAILURE:
        return initialState
      default:
        return state
    }
  },
  licensetypeInfo: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_LICENSETYPE_REQUEST:
        return requestState
      case CORE_LOAD_LICENSETYPE_SUCCESS:
        if (action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload)) {
          return action.payload
        } else return {}
      case CORE_LOAD_LICENSETYPE_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerLicensetype.js